export default __webpack_public_path__ + "static/media/tomasz.237a4adb.png";